import React from 'react';
import './SudokuBoard.css';

const SudokuBoard = ({ board, onCellClick, isLoading, initialRemovalInProgress }) => {
  if (!board) return <div className="loading-board">読み込み中...</div>;

  return (
    <div className={`sudoku-board ${initialRemovalInProgress ? 'initial-removal' : ''}`}>
      {board.map((row, rowIndex) => (
        <div key={`row-${rowIndex}`} className="board-row">
          {row.map((cell, colIndex) => (
            <div
              key={`cell-${rowIndex}-${colIndex}`}
              className={`
                board-cell
                ${(rowIndex + 1) % 3 === 0 && rowIndex < 8 ? 'border-bottom' : ''}
                ${(colIndex + 1) % 3 === 0 && colIndex < 8 ? 'border-right' : ''}
                ${cell === 0 ? 'empty-cell' : 'filled-cell'}
                ${initialRemovalInProgress ? 'disabled' : ''}
              `}
              onClick={() => !isLoading && !initialRemovalInProgress && onCellClick(rowIndex, colIndex)}
            >
              {cell !== 0 ? cell : ''}
            </div>
          ))}
        </div>
      ))}
      {initialRemovalInProgress && (
        <div className="removal-overlay">
          <div className="removal-message">自動消去中...</div>
        </div>
      )}
    </div>
  );
};

export default SudokuBoard;
